// extracted by mini-css-extract-plugin
export default {"column":"ReportFilter_column__ob0dH","placeHolderShimmer":"ReportFilter_placeHolderShimmer__4KxSl"};